import type { InteractiveLessonSectionComponentFragment } from '../../lesson-builder.graphql.generated';
import { ComponentImage } from '../component.constants';
import { ImageProperties } from './image.constants';
import { removeTypenameFromObject } from 'approot/shared/logic/remove-typename';

export function getBaseImagePayload(properties: ImageProperties) {
  return {
    caption: properties.caption,
    altText: properties.altText,
    showCaptionOnLesson: properties.showCaptionOnLesson,
    stimulusId: properties.stimulusId,
    cropData: properties.cropData
      ? removeTypenameFromObject(properties.cropData)
      : null,
    dimensionData: removeTypenameFromObject(properties.dimensionData),
  };
}

export function hasImage(
  component: InteractiveLessonSectionComponentFragment
): boolean {
  if (component.type !== 'image') return false;

  const imageComponent = component as ComponentImage;
  return !!(
    hasStimulusImage(component) || imageComponent.properties.image?.original
  );
}

export function hasStimulusImage(
  component: InteractiveLessonSectionComponentFragment
): boolean {
  const imageComponent = component as ComponentImage;
  return !!imageComponent.stimulusResourceProperties?.image?.original;
}
